var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import * as React from 'react';
import styled from '@emotion/styled';
import TooltipTrigger from 'react-popper-tooltip';
import { TooltipArrow } from "./TooltipArrow";
import { TooltipContainer } from "./TooltipContainer";
var Trigger = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));

function getTooltipRenderer(hideArrow, tooltip) {
  return function (_ref) {
    var arrowRef = _ref.arrowRef,
        tooltipRef = _ref.tooltipRef,
        getArrowProps = _ref.getArrowProps,
        getTooltipProps = _ref.getTooltipProps,
        placement = _ref.placement;
    return /*#__PURE__*/React.createElement(TooltipContainer, getTooltipProps({
      ref: tooltipRef
    }), !hideArrow && /*#__PURE__*/React.createElement(TooltipArrow, getArrowProps({
      ref: arrowRef,
      'data-placement': placement
    })), tooltip);
  };
}

var getTriggerRenderer = function getTriggerRenderer(_ref2) {
  var children = _ref2.children,
      shouldWrapChildren = _ref2.shouldWrapChildren;
  return function (_ref3) {
    var getTriggerProps = _ref3.getTriggerProps,
        triggerRef = _ref3.triggerRef;
    var triggerProps = getTriggerProps({
      ref: triggerRef
    });
    var clone;

    if (typeof children === 'string' || shouldWrapChildren) {
      clone = /*#__PURE__*/React.createElement(Trigger, triggerProps, children);
    } else {
      clone = /*#__PURE__*/React.cloneElement(React.Children.only(children), triggerProps);
    }

    return clone;
  };
};

var modifiers = [{
  name: 'offset',
  options: {
    offset: [0, 8]
  }
}];
export var Tooltip = function Tooltip(_ref4) {
  var children = _ref4.children,
      tooltip = _ref4.tooltip,
      _ref4$hideArrow = _ref4.hideArrow,
      hideArrow = _ref4$hideArrow === void 0 ? false : _ref4$hideArrow,
      _ref4$shouldWrapChild = _ref4.shouldWrapChildren,
      shouldWrapChildren = _ref4$shouldWrapChild === void 0 ? false : _ref4$shouldWrapChild,
      _ref4$placement = _ref4.placement,
      placement = _ref4$placement === void 0 ? 'bottom' : _ref4$placement,
      _ref4$trigger = _ref4.trigger,
      trigger = _ref4$trigger === void 0 ? 'hover' : _ref4$trigger,
      _ref4$delay = _ref4.delay,
      delay = _ref4$delay === void 0 ? 200 : _ref4$delay,
      isOpen = _ref4.isOpen;

  if (!tooltip) {
    return children;
  }

  return /*#__PURE__*/React.createElement(TooltipTrigger, {
    tooltipShown: isOpen,
    modifiers: modifiers,
    placement: placement,
    trigger: trigger,
    delayShow: delay,
    tooltip: getTooltipRenderer(hideArrow, tooltip)
  }, getTriggerRenderer({
    children: children,
    shouldWrapChildren: shouldWrapChildren
  }));
};
Tooltip.displayName = 'Tooltip';